import styled from 'styled-components';

export const StyledLoader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
`;
